var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPer5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_1",
    "data-name": "Component 19 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#67b0fc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket_launch_black_24dp",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10868",
    "data-name": "Group 10868"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3240",
    "data-name": "Rectangle 3240",
    width: 36,
    height: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10870",
    "data-name": "Group 10870",
    transform: "translate(3 3.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10869",
    "data-name": "Group 10869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14370",
    "data-name": "Path 14370",
    d: "M8,21.5a4.489,4.489,0,0,0-3.18,1.32C3.05,24.59,2,32,2,32s7.41-1.05,9.18-2.82A4.5,4.5,0,0,0,8,21.5Zm1.065,5.565A15.235,15.235,0,0,1,5.81,28.2,14.7,14.7,0,0,1,6.95,24.95,1.391,1.391,0,0,1,8,24.5a1.506,1.506,0,0,1,1.065,2.565Zm16.065-7.59h0C34.67,9.935,31.49,2.51,31.49,2.51S24.065-.67,14.525,8.87L10.79,8.12a3.045,3.045,0,0,0-2.715.825L2,15.035l7.5,3.21L15.755,24.5l3.21,7.5,6.075-6.075a3.02,3.02,0,0,0,.825-2.715Zm-15.015-4.23L7.25,14.015,10.2,11.06l2.16.435A37.554,37.554,0,0,0,10.115,15.245Zm9.87,11.505-1.23-2.865a35.767,35.767,0,0,0,3.735-2.25l.435,2.16ZM23,17.36a25.75,25.75,0,0,1-6.06,4.095l-4.4-4.4A25.412,25.412,0,0,1,16.64,11c7.02-7.02,12.345-5.985,12.345-5.985S30.02,10.34,23,17.36ZM21.5,15.5a3,3,0,1,0-3-3A3.009,3.009,0,0,0,21.5,15.5Z",
    transform: "translate(-2 -2.001)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPer5);
export default __webpack_public_path__ + "static/media/per_5.e9047b683d67f96eb4bbd4968c97b698.svg";
export { ForwardRef as ReactComponent };